

export default {
  name: "HappyKidsLastYearEntry",
  props: {
    data: {
        type: Object,
        default: () => {}
    }
  },
};
